import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import { ContactForm } from '../ContactForm/ContactForm';
import { useLanguage } from '../../context/LanguageContext';

export default function ContactSection() {
  const { t, isRTL } = useLanguage();
  return (
    <section className="relative  mt-12 sm:mt-16 lg:mt-56">
      <div className="relative">
        
        
        <div className="py-12 sm:py-16 px-5  bg-gradient-to-r from-secondary to-primary">
            <div className='max-w-4xl mx-auto'>
                <h1 className='text-center text-2xl font-roboto font-bold text-white md:text-6xl'>{t('contact.getInTouch')}</h1>
                <p className='text-center text-sm font-roboto font-semibold text-white md:text-xl py-5'>{t('contact.description')}</p>

          <ContactForm/>
            </div>
        </div>
      </div>
    </section>
  );
}